import { cn } from "@/lib/utils";
import * as React from "react";

export type DividerProps = React.ComponentProps<"hr"> & {
  className?: string;
  spacing?: 0 | 8 | 12 | 16 | 24 | 32 | 40 | 48 | 56 | 64;
};

export const Divider = ({
  className,
  spacing = 32,
  ...hrProps
}: DividerProps) => {
  return (
    <hr
      className={cn(
        "tw-border-gray-300 tw-h-[1px] tw-w-full tw-block",
        {
          "tw-my-8": spacing === 8,
          "tw-my-12": spacing === 12,
          "tw-my-16": spacing === 16,
          "tw-my-24": spacing === 24,
          "tw-my-32": spacing === 32,
          "tw-my-40": spacing === 40,
          "tw-my-48": spacing === 48,
          "tw-my-56": spacing === 56,
          "tw-my-64": spacing === 64,
        },
        className,
      )}
      {...hrProps}
    />
  );
};
